import { useQuery } from '@apollo/client/react';
import {
  GET_VENDOR_TYPES,
  GET_VENDOR_SUBTYPES,
  GET_DAY_OF_WEEK,
  GET_SUPPORTED_LANGUAGES,
} from 'api/graphql/common';
import env from 'config/env';

/**
 * Reference data for the shop form: vendor types, business types (subtypes of
 * the selected vendor type), days of week and supported languages.
 */
export function useShopEnums(vendorType) {
  const languageCode = env.defaultLanguage;

  const typesQuery = useQuery(GET_VENDOR_TYPES, { variables: { languageCode } });
  const subtypesQuery = useQuery(GET_VENDOR_SUBTYPES, {
    variables: { vendorType, languageCode },
    skip: !vendorType,
  });
  const daysQuery = useQuery(GET_DAY_OF_WEEK, { variables: { languageCode } });
  const languagesQuery = useQuery(GET_SUPPORTED_LANGUAGES);

  return {
    vendorTypes: typesQuery.data?.getVendorTypes ?? [],
    businessTypes: subtypesQuery.data?.getVendorSubtypes ?? [],
    days: daysQuery.data?.getDayOfWeek ?? [],
    languages: (languagesQuery.data?.getSupportedLanguages ?? []).filter(
      (lang) => lang.isTranslationActive,
    ),
    loading: typesQuery.loading || daysQuery.loading,
  };
}

/** Map a supported-language entry to its `SupportedLanguage` enum value. */
export function languageEnumValue(lang) {
  if (lang.code === 'en') return 'ENGLISH';
  if (lang.code === 'hi') return 'HINDI';
  if (lang.code === 'te') return 'TELUGU';
  return (lang.displayName || '').toUpperCase();
}
